import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Toast from "@/Components/Feedback/Toast";

const ToastContainer = ({toasts}) => {

    const animateToast = {
        initial: { x: '100%'},
        animate: { x: 0 },
        exit: { scale: 0.2, x: '100%' }
    }

    return (
        <div className='fixed right-4 bottom-4 z-front w-9/12 sm:w-5/12 md:w-4/12 lg:w-3/12 xl:w-3/12 2xl:w-2/12'>
            <AnimatePresence>
                {toasts.map((item) =>(
                    <motion.div key={item.id} variants={animateToast} initial='initial' animate='animate' exit='exit'>
                        <Toast  id={item.id} content={item.content} variant={item.variant} />
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
        
     );
}
 
export default ToastContainer;